// TODO remove this piece of code
export default {
  fastCopy(data) {
    return JSON.parse(JSON.stringify(data))
  }

}
